<template>
  <div class="bao-duong-right-panel" v-if="currentTicket">
    <!-- CHAT -->
    <div class="card mb-3 chat-card">
      <div
        class="card-header py-2 d-flex justify-content-between align-items-center"
      >
        <div>
          <i class="fa fa-comments mr-1"></i>
          Trao đổi trong phiếu
        </div>
        <small class="text-muted" v-if="isLoadingChat">Đang tải...</small>
      </div>

      <div class="card-body p-2 chat-body">
        <div
          v-if="chatError"
          class="alert alert-danger py-1 small mb-2"
        >
          {{ chatError }}
        </div>

        <div
          v-if="isLoadingChat && !chatMessages.length"
          class="small text-muted text-center py-2"
        >
          Đang tải lịch sử trao đổi...
        </div>

        <div
          v-else-if="!chatMessages.length"
          class="small text-muted text-center py-2"
        >
          Chưa có trao đổi nào. Nhắn tin để bắt đầu trao đổi giữa
          tài xế &amp; admin.
        </div>

        <div v-else class="chat-messages">
          <template v-for="m in chatMessages" :key="m.id || m.label">
            <!-- HEADER NGÀY -->
            <div
              v-if="m.type === 'header'"
              class="chat-date-header"
            >
              {{ m.label }}
            </div>

            <!-- TIN NHẮN -->
            <div
              v-else
              class="chat-message"
              :class="{ me: m.isMine }"
            >
              <div class="chat-bubble">
                <!-- META: tên người gửi / nhận -->
                <div class="chat-meta">
                  <strong class="chat-from">
                    {{ m.isMine ? (localUserName || 'Tôi') : (m.fromName || 'Không rõ') }}
                  </strong>
                  <span v-if="m.toName" class="chat-arrow">→</span>
                  <span v-if="m.toName" class="chat-to">
                    {{ m.toName }}
                  </span>
                </div>

                <!-- TEXT -->
                <div class="chat-text">
                  {{ m.text }}
                </div>

                <!-- IMAGE -->
                <div v-if="m.attachmentUrl" class="chat-img-wrapper">
                  <img
                    :src="m.attachmentUrl"
                    class="chat-img"
                    @click="onOpenLightbox && onOpenLightbox(m.attachmentUrl)"
                  />
                </div>

                <!-- TIME -->
                <div class="chat-time">
                  {{ formatDateTime ? formatDateTime(m.createdAt) : m.createdAt }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="card-footer p-2">
        <form @submit.prevent="$emit('send-chat')">
          <div class="input-group input-group-sm">
            <textarea
              v-model.trim="chatForm.text"
              class="form-control"
              rows="1"
              placeholder="Nhập nội dung, Enter để gửi, Shift+Enter xuống dòng"
              @keyup.enter.exact.prevent="$emit('send-chat')"
              @keyup.enter.shift.stop
            ></textarea>
            <div class="input-group-append">
              <button
                type="button"
                class="btn btn-outline-secondary"
                title="Đính kèm ảnh"
                @click="onOpenPicker && onOpenPicker('chat_attachment')"
              >
                <i class="fa fa-paperclip"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary"
                title="Chụp ảnh"
                @click="onOpenCamera && onOpenCamera('chat_attachment')"
              >
                <i class="fa fa-camera"></i>
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="
                  isSendingChat ||
                  (!chatForm.text && !chatForm.attachmentUrl)
                "
              >
                <span
                  v-if="isSendingChat"
                  class="spinner-border spinner-border-sm"
                ></span>
                <i v-else class="fa fa-paper-plane"></i>
              </button>
            </div>
          </div>

          <small
            v-if="chatForm.attachmentUrl"
            class="small text-muted d-block mt-1"
          >
            Đã chọn ảnh đính kèm.
            <a
              href="javascript:void(0)"
              @click="onOpenLightbox && onOpenLightbox(chatForm.attachmentUrl)"
            >
              Xem
            </a>
            ·
            <a
              href="javascript:void(0)"
              @click="chatForm.attachmentUrl = null"
            >
              Xóa
            </a>
          </small>
        </form>
      </div>
    </div>

    <!-- ACTION PANEL THEO TRẠNG THÁI -->
    <!-- MOI -->
    <div
      v-if="currentTicket.trangThai === 'MOI'"
      class="p-3 bg-light rounded mb-3"
    >
      <h5>
        <i class="fa fa-route mr-2"></i>Hướng xử lý
      </h5>
      <p class="small text-muted">
        Sau khi trao đổi trong chat, chọn <b>1 hướng xử lý
        chính</b>.<br />
        - Nếu chọn <b>Ra gara</b> thì nhập tên Gara/Nơi
        sửa.<br />
        - Không dùng giá đề xuất nữa, chi phí thực tế sẽ nhập ở
        bước hoàn thành sửa.
      </p>

      <form @submit.prevent="$emit('submit-bao-gia')">
        <div class="form-group">
          <label>
            Hướng xử lý <span class="text-danger">*</span>
          </label>
          <select
            v-model="formGia.huongXuLy"
            class="form-control"
            required
          >
            <option :value="null">-- Chưa chọn --</option>
            <option
              v-for="opt in huongXuLyOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
          <small class="text-muted">
            Ví dụ: mua phụ tùng về thay, đưa ra gara, hoặc dời
            lịch xử lý sau.
          </small>
        </div>

        <div
          class="form-group"
          v-if="formGia.huongXuLy === 'RA_GARA'"
        >
          <label>
            Tên Gara / Nơi sửa
            <span class="text-danger">*</span>
          </label>
          <input
            v-model.trim="formGia.garaDeXuat"
            class="form-control"
            required
          />
          <small class="text-muted">
            Nhập tên gara hoặc nơi sửa để tiện theo dõi.
          </small>
        </div>

        <div class="form-group">
          <label>Ảnh Báo giá/Biên lai (Nếu có)</label>

          <div v-if="formGia.anhBaoGiaUrl" class="mb-2">
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="form-control"
                :value="formGia.anhBaoGiaUrl"
                readonly
                @click="onOpenLightbox && onOpenLightbox(formGia.anhBaoGiaUrl)"
                style="cursor: pointer"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-outline-danger"
                  @click="formGia.anhBaoGiaUrl = null"
                >
                  Xóa
                </button>
              </div>
            </div>
          </div>

          <div v-else class="btn-group">
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              @click="onOpenPicker && onOpenPicker('formGia_anhBaoGiaUrl')"
            >
              <i class="fa fa-upload mr-1"></i>
              Tải lên / Chọn
            </button>

            <!-- CameraCapture dùng riêng, không đụng tới picker chung -->
            <CameraCapture
              v-model="formGia.anhBaoGiaUrl"
              folder-name="bao_duong_bao_gia"
              file-name-prefix="bao-gia"
              modal-title="Chụp ảnh Báo Giá"
              button-text="Chụp ảnh"
              button-class="btn-sm btn-outline-secondary"
              :disabled="isLoadingDetail"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-warning btn-block"
          :disabled="isLoadingDetail"
        >
          <span
            v-if="isLoadingDetail"
            class="spinner-border spinner-border-sm"
          ></span>
          <i v-else class="fa fa-play-circle"></i>
          Xác nhận Hướng xử lý
        </button>
      </form>
    </div>

    <!-- DANG_SUA -->
    <div
      v-if="currentTicket.trangThai === 'DANG_SUA'"
      class="p-3 bg-light rounded mb-3"
    >
      <h5>
        <i class="fa fa-check-square mr-2"></i>
        Xác nhận Hoàn thành
      </h5>
      <p class="small text-muted">
        Tài xế nhập thông tin sau khi mua hàng / gara sửa xong và
        có biên lai.
      </p>

      <form @submit.prevent="$emit('hoan-thanh')">
        <div class="form-group">
          <label>
            ODO lúc hoàn thành (Km)
            <span class="text-danger">*</span>
          </label>
          <input
            v-model.number="formHoanThanh.odoHoanThanh"
            type="number"
            class="form-control"
            min="1"
            required
          />
        </div>
        <div class="form-group">
          <label>
            Chi phí thực tế (VND)
            <span class="text-danger">*</span>
          </label>
          <input
            v-model="formHoanThanh.chiPhiThucTe"
            type="number"
            step="0.01"
            min="0"
            inputmode="decimal"
            class="form-control"
            required
          />
        </div>

        <div class="form-group">
          <label>
            Ảnh Biên lai/Hóa đơn
            <span class="text-danger">*</span>
          </label>

          <div v-if="formHoanThanh.bienLaiUrl" class="mb-2">
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="form-control"
                :value="formHoanThanh.bienLaiUrl"
                readonly
                @click="onOpenLightbox && onOpenLightbox(formHoanThanh.bienLaiUrl)"
                style="cursor: pointer"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-outline-danger"
                  @click="formHoanThanh.bienLaiUrl = null"
                >
                  Xóa
                </button>
              </div>
            </div>
          </div>

          <div v-else class="btn-group">
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              @click="onOpenPicker && onOpenPicker('bienLaiUrl')"
            >
              <i class="fa fa-upload mr-1"></i>
              Tải lên / Chọn
            </button>

            <CameraCapture
              v-model="formHoanThanh.bienLaiUrl"
              folder-name="bao_duong_bien_lai"
              file-name-prefix="bien-lai"
              modal-title="Chụp ảnh Biên Lai"
              button-text="Chụp ảnh"
              button-class="btn-sm btn-outline-secondary"
              :disabled="isLoadingDetail"
            />
          </div>

          <!-- input ẩn chỉ để satisfy required -->
          <input
            type="text"
            :value="formHoanThanh.bienLaiUrl"
            required
            style="
              width: 0;
              height: 0;
              padding: 0;
              border: none;
              opacity: 0;
              position: absolute;
            "
            tabindex="-1"
            aria-hidden="true"
            @focus.prevent
          />
        </div>

        <button
          type="submit"
          class="btn btn-info btn-block"
          :disabled="isLoadingDetail"
        >
          <span
            v-if="isLoadingDetail"
            class="spinner-border spinner-border-sm"
          ></span>
          <i class="fa fa-flag-checkered" v-else></i>
          Gửi Xác nhận Hoàn thành
        </button>
      </form>
    </div>

    <!-- CHO_THANH_TOAN -->
    <div
      v-if="currentTicket.trangThai === 'CHO_THANH_TOAN'"
      class="p-3 bg-light rounded mb-3"
    >
      <h5>
        <i class="fa fa-file-invoice-dollar mr-2"></i>
        Xác nhận Thanh toán
      </h5>
      <p class="small text-muted">
        Kế toán / Admin đối soát biên lai và xác nhận thanh toán.
      </p>
      <div class="alert alert-info py-2 small">
        Chi phí thực tế:
        <strong>{{
          formatCurrency ? formatCurrency(currentTicket.chiPhiThucTe) : currentTicket.chiPhiThucTe
        }}</strong
        ><br />
        Chi phí đã duyệt:
        <strong>{{
          formatCurrency ? formatCurrency(currentTicket.giaDuocDuyet) : currentTicket.giaDuocDuyet
        }}</strong
        ><br />
        <button
          v-if="currentTicket.bienLaiUrl"
          type="button"
          class="btn btn-sm btn-outline-dark mt-1"
          @click="onOpenLightbox && onOpenLightbox(currentTicket.bienLaiUrl)"
        >
          <i class="fa fa-file-invoice"></i> Xem biên lai
        </button>
      </div>

      <form @submit.prevent="$emit('thanh-toan')">
        <div class="form-group">
          <label>Ghi chú thanh toán (Tùy chọn)</label>
          <input
            v-model.trim="formThanhToan.ghiChu"
            class="form-control"
          />
        </div>
        <button
          type="submit"
          class="btn btn-success btn-block"
          :disabled="isLoadingDetail"
        >
          <span
            v-if="isLoadingDetail"
            class="spinner-border spinner-border-sm"
          ></span>
          <i v-else class="fa fa-check"></i>
          Xác nhận Đã Thanh toán
        </button>
      </form>
    </div>

    <!-- ĐÃ ĐÓNG -->
    <div
      v-if="
        currentTicket.trangThai === 'HOAN_THANH' ||
        currentTicket.trangThai === 'DA_HUY'
      "
      class="p-3 text-center text-muted"
    >
      <i
        class="fa fa-check-circle fa-2x mb-2 text-success"
        v-if="currentTicket.trangThai === 'HOAN_THANH'"
      ></i>
      <i
        class="fa fa-times-circle fa-2x mb-2 text-secondary"
        v-if="currentTicket.trangThai === 'DA_HUY'"
      ></i>
      <p>Phiếu này đã được đóng.</p>
    </div>
  </div>
</template>

<script>
import CameraCapture from "@/components/CameraCapture.vue";

export default {
  name: "BaoDuongChatActionPanel",
  components: { CameraCapture },
  props: {
    currentTicket: { type: Object, required: true },

    // CHAT
    chatMessages: { type: Array, default: () => [] },
    chatForm: { type: Object, required: true },
    isLoadingChat: { type: Boolean, default: false },
    isSendingChat: { type: Boolean, default: false },
    chatError: { type: String, default: null },
    localUserName: { type: String, default: "" },

    // ACTION FORMS
    huongXuLyOptions: { type: Array, default: () => [] },
    formGia: { type: Object, required: true },
    formHoanThanh: { type: Object, required: true },
    formThanhToan: { type: Object, required: true },
    isLoadingDetail: { type: Boolean, default: false },

    // helper funcs từ parent
    formatCurrency: { type: Function, default: null },
    formatDateTime: { type: Function, default: null },

    // callback funcs cho picker / camera / lightbox
    onOpenPicker: { type: Function, default: null },
    onOpenCamera: { type: Function, default: null },
    onOpenLightbox: { type: Function, default: null },
  },
  emits: ["send-chat", "submit-bao-gia", "hoan-thanh", "thanh-toan"],
};
</script>

<style scoped>
/* CHAT */
.chat-card {
  display: flex;
  flex-direction: column;
}

.chat-body {
  flex: 0 1 auto;
  padding-bottom: 0;
}

/* khung scroll cho messages, không kéo cả card */
.chat-messages {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
}

/* header ngày kiểu Zalo */
.chat-date-header {
  text-align: center;
  background: #d8d8d8;
  color: #ffffff;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin: 10px auto;
  width: fit-content;
}

.chat-message {
  display: flex;
  margin: 6px 0;
  justify-content: flex-start;
}

/* tin của mình bên phải */
.chat-message.me {
  justify-content: flex-end;
}

/* ====== ĐIỂM MẤU CHỐT: bubble tự co, max 70% ====== */
.bao-duong-right-panel .chat-message .chat-bubble {
  display: inline-block !important;   /* không full width nữa */
  flex: 0 0 auto !important;          /* không kéo giãn theo flex */
  max-width: 70% !important;          /* cùng ý với TicketView */
  padding: 8px 10px;
  border-radius: 8px;
  background: #f1f3f5;
  font-size: 13px;
}

/* bubble của mình khác màu */
.bao-duong-right-panel .chat-message.me .chat-bubble {
  background: #b9daff;
}

/* meta tên người gửi / nhận */
.chat-meta {
  font-size: 11px;
  margin-bottom: 3px;
  color: #555;
}

.chat-message.me .chat-meta {
  text-align: right;
}

.chat-from {
  font-weight: 600;
}

.chat-arrow {
  margin: 0 4px;
}

.chat-to {
  opacity: 0.8;
}

/* nội dung */
.chat-text {
  white-space: pre-wrap;
  word-break: break-word;
}

/* ảnh đính kèm */
.chat-img-wrapper {
  margin-top: 5px;
}

.chat-img {
  max-width: 160px;
  max-height: 160px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #dee2e6;
}

/* thời gian */
.chat-time {
  margin-top: 3px;
  font-size: 11px;
  color: #666;
  text-align: right;
}

@media (max-width: 767.98px) {
  .chat-card {
    max-height: 60vh;
  }
}
</style>

